import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SnSessionService } from '../../services';

@Component({
  selector: 'sn-soo-mobile-saml',
  templateUrl: './sso-mobile-saml.component.html',
  styleUrls: ['./sso-mobile-saml.component.scss'],
})
export class SsoMobileSamlComponent implements OnInit, OnDestroy {
  public options: any[];
  public isLoading = true;
  private readonly _destroy$ = new Subject();

  constructor(
    private readonly _route: ActivatedRoute,
    private readonly _router: Router,
    private readonly _sessionService: SnSessionService,
  ) {}

  public ngOnInit(): void {
    this._route.params
      .pipe(takeUntil(this._destroy$))
      .subscribe(({ email }) => this._fetchProvidersByEmail(email));
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public goToProvider(provider: any): void {
    window.location = provider.redirectUrl;
  }

  private _fetchProvidersByEmail(email: string): void {
    this.isLoading = true;
    const app = this._route.parent.snapshot.params.app || 'ops';
    const test = this._route.parent.snapshot.queryParams.isTest || false;
    this._sessionService
      .providersByEmail(email, app, test)
      .pipe(takeUntil(this._destroy$))
      .subscribe((provider: any) => {
        if (provider.count === 0) {
          this._router.navigateByUrl('/auth/sign-in');
          return;
        }
        localStorage.setItem('app-origin', this._route.parent.snapshot.params.app);
        this.options = provider.results;
        this.isLoading = false;
      });
  }
}
